import styled from 'styled-components'

const AccordionStyle = styled.div`
	--accordionSummaryPadding: var(--sp10x);
	--accordionDescriptionPadding: 0 var(--sp10x) var(--sp14x);
	--accordionIconSizes: var(--sp6x);
	--accordionBorderRadius: var(--sp6x);
	--accordionDescriptionMaxWidth: calc(var(--sp200x) + var(--sp35x));

	&.first {
		.accordion {
			.accordion-summary {
				border-radius: var(--accordionBorderRadius) var(--accordionBorderRadius) 0 0;
			}
		}
	}

	&.last {
		.accordion {
			.accordion-summary {
				border-radius: 0 0 var(--accordionBorderRadius) var(--accordionBorderRadius);
				border-bottom: none;
			}

			&::before {
				display: none;
			}
		}

		.accordion {
			&.active {
				.accordion-description-wrap {
					border-radius: 0 0 var(--accordionBorderRadius) var(--accordionBorderRadius);
				}
			}
		}
	}

	&.one-item {
		.accordion {
			.accordion-summary {
				border-radius: var(--accordionBorderRadius);
				border-bottom: 1px solid transparent;
			}

			&::before {
				display: none;
			}
		}
	}

	&.one-item.active {
		.accordion {
			.accordion-summary {
				border-radius: var(--accordionBorderRadius) var(--accordionBorderRadius) 0 0;
			}
		}
	}

	.accordion {
		position: relative;
		box-shadow: none;
		background: transparent;
		overflow: hidden;
		cursor: pointer;

		&::before {
			content: '';
			display: block;
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 1px;
			background-color: var(--secondaryColor2);
			opacity: 40%;
			z-index: 1;
		}

		&.active {
			.collapse {
				max-height: 1000px;
				transition: max-height calc(var(--trTime) * 2);
			}

			.accordion-description-wrap {
				background-color: var(--primaryColor3);
			}

			.accordion-summary {
				background-color: var(--primaryColor3);

				.accordion-arrow {
					transform: rotate(-90deg);
				}
			}
		}

		.collapse {
			max-height: 0px;
			transition: max-height var(--trTime);
		}

		.accordion-summary {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			position: relative;
			margin: 0;
			padding: var(--accordionSummaryPadding);
			background-color: var(--secondaryColor4);
			transition: var(--trTime);

			.title-wrap {
				display: flex;
                align-items: center;
				justify-content: space-between;
				width: 100%;
			}

			.accordion-arrow {
				transform: rotate(90deg);
				font-size: var(--accordionIconSizes);
				transition: transform var(--trTime);
			}
		}

		.accordion-description-wrap {
			background-color: var(--secondaryColor4);
			transition: background-color var(--trTime);
			padding: var(--accordionDescriptionPadding);
			padding: 0;

			.accordion-description {
				max-width: var(--accordionDescriptionMaxWidth);
				padding-top: var(--accordionSummaryPadding);
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--accordionSummaryPadding: var(--sp8x);
		--accordionIconSizes: var(--sp5x);
		--accordionDescriptionPadding: 0 var(--sp8x) var(--sp10x);
		--accordionDescriptionMaxWidth: var(--sp175x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--accordionSummaryPadding: var(--sp7x);
		--accordionIconSizes: var(--sp4x);
		--accordionDescriptionPadding: 0 var(--sp7x) var(--sp9x);
		--accordionDescriptionMaxWidth: var(--sp126x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--accordionSummaryPadding: var(--sp7x);
		--accordionIconSizes: var(--sp4x);
		--accordionDescriptionPadding: 0 var(--sp7x) var(--sp9x);
		--accordionDescriptionMaxWidth: var(--sp120x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--accordionSummaryPadding: var(--sp6x);
		--accordionIconSizes: var(--sp3x);
		--accordionDescriptionPadding: 0 var(--sp6x) var(--sp8x);
		--accordionDescriptionMaxWidth: var(--sp111x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--accordionSummaryPadding: var(--sp5x);
		--accordionIconSizes: var(--sp3x);
		--accordionDescriptionPadding: 0 var(--sp5x) var(--sp7x);
		--accordionDescriptionMaxWidth: var(--sp93x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--accordionSummaryPadding: var(--sp5x);
		--accordionIconSizes: var(--sp3x);
		--accordionDescriptionPadding: 0 var(--sp5x) var(--sp7x);
		--accordionDescriptionMaxWidth: 100%;
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--accordionSummaryPadding: var(--sp4x);
		--accordionIconSizes: var(--sp2x);
		--accordionDescriptionPadding: 0 var(--sp4x) var(--sp6x);
		--accordionDescriptionMaxWidth: 100%;
	}
`

export default AccordionStyle
